class SvgFramePlayer {
  /**
   * @param {HTMLElement} wrapElement - 包含所有 <g id="frame_xx"> 的 SVG 元素
   * @param {Object} options
   * @param {number} [options.fps=24] - 播放帧率
   */
  constructor(wrapElement, { fps = 24 } = {}) {
    if (!wrapElement) throw new Error("wrapElement is required");
    this.wrap = wrapElement;
    this.fps = fps;
    this.interval = 1000 / this.fps;

    // 获取所有帧（按数字顺序）
    this.frames = Array.from(this.wrap.querySelectorAll('g[id^="frame_"]'))
      .sort((a, b) => {
        const getNum = el => parseInt(el.id.split('_')[1], 10);
        return getNum(a) - getNum(b);
      });

    if (!this.frames.length) throw new Error("No frames found with id='frame_xx'");

    this.totalFrames = this.frames.length;
    this.currentFrame = 0;
    this.isPlaying = false;
    this._raf = null;
    this._targetFrame = null;

    // 初始化：显示第一帧
    this._showFrame(this.currentFrame);
  }

  /** 内部方法：只显示指定帧 */
  _showFrame(frameIndex) {
    this.frames.forEach((f, i) => {
      f.style.display = i === frameIndex ? '' : 'none';
    });
  }

  /** 停止播放 */
  stop() {
    this.isPlaying = false;
    if (this._raf) cancelAnimationFrame(this._raf);
    this._raf = null;
    this._targetFrame = null;
  }

  /**
   * 播放到指定帧
   * @param {number} targetFrame - 要播放到的帧索引（0-based）
   */
  playTo(targetFrame) {
    if (targetFrame < 0 || targetFrame >= this.totalFrames)
      throw new Error(`targetFrame must be between 0 and ${this.totalFrames - 1}`);

    this._targetFrame = targetFrame;
    this.isPlaying = true;
    this._lastTime = performance.now();
    this._raf = requestAnimationFrame(this._update.bind(this));
  }

  /** 直接切换到指定帧（不播放） */
  goTo(frameIndex) {
    if (frameIndex < 0 || frameIndex >= this.totalFrames)
      throw new Error(`frameIndex must be between 0 and ${this.totalFrames - 1}`);

    this.stop();
    this.currentFrame = frameIndex;
    this._showFrame(this.currentFrame);
  }

  /** 内部更新逻辑 */
  _update(timestamp) {
    if (!this.isPlaying) return;

    const elapsed = timestamp - this._lastTime;
    if (elapsed >= this.interval) {
      if (this._targetFrame !== null) {
        if (this.currentFrame < this._targetFrame) this.currentFrame++;
        else if (this.currentFrame > this._targetFrame) this.currentFrame--;
        else {
          this.stop();
          return;
        }
      } else {
        this.currentFrame = (this.currentFrame + 1) % this.totalFrames;
      }

      this._showFrame(this.currentFrame);
      this._lastTime = timestamp;
    }

    this._raf = requestAnimationFrame(this._update.bind(this));
  }
}

window.SvgFramePlayer = SvgFramePlayer;
